'use client';

import Link from 'next/link';
import { useAuth } from '@/hooks/useAuth';

interface LpCtaButtonProps {
  className?: string;
}

export default function LpCtaButton({ className }: LpCtaButtonProps) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return null;
  }

  return (
    <div className={className}>
      <Link
        href="/user/signup"
        className="relative block rounded-full bg-primary px-5 py-4 text-center text-base font-bold text-white transition-opacity hover:opacity-60 md:py-3 md:text-sm"
      >
        会員登録はこちら
        <span className="absolute right-7 top-1/2 block h-4 w-4 -translate-y-1/2 bg-[url('/lp/user/icon_arrow_w.svg')] bg-contain bg-no-repeat" />
      </Link>
    </div>
  );
}
